<template>
  <div class="frisbuy-text-modal" @click.self="emit('close')">
    <div class="frisbuy-text-modal__card" role="dialog" aria-modal="true">
      <div class="frisbuy-text-modal__header">
        <button
          class="frisbuy-text-modal__close"
          type="button"
          aria-label="Close"
          @click="emit('close')"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.6077 6.29437C17.2138 5.90724 16.5807 5.91272 16.1936 6.3066L11.9878 10.5857L7.70878 6.38003C7.31489 5.9929 6.68175 5.99838 6.29462 6.39227C5.90748 6.78615 5.91296 7.4193 6.30685 7.80643L10.5859 12.0121L6.38006 16.2914C5.99293 16.6852 5.9984 17.3184 6.39229 17.7055C6.78618 18.0926 7.41932 18.0872 7.80645 17.6933L12.0123 13.414L16.2916 17.6199C16.6855 18.0071 17.3186 18.0016 17.7058 17.6077C18.0929 17.2138 18.0874 16.5807 17.6935 16.1935L13.4142 11.9876L17.6199 7.70853C18.0071 7.31465 18.0016 6.6815 17.6077 6.29437Z"
              fill="#999999"
            />
          </svg>
        </button>
      </div>

      <div class="frisbuy-text-modal__scroll">
        <div class="frisbuy-text-modal__head">
          <div class="frisbuy-text-modal__author">
            <div class="frisbuy-text-modal__avatar" :style="avatarStyle">
              {{ authorInitial }}
            </div>
            <div class="frisbuy-text-modal__meta">
              <div class="frisbuy-text-modal__name">{{ authorName }}</div>
              <div class="frisbuy-text-modal__date">{{ props.reviewDate }}</div>
            </div>
          </div>

          <div
            v-if="props.post.frisbuyPost.rating"
            class="frisbuy-text-modal__rating"
          >
            <span class="frisbuy-text-modal__rating-icon" aria-hidden="true">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.5475 9.00373L14.3506 8.38782L12.4744 4.54711C12.4232 4.44196 12.3389 4.35683 12.2348 4.30509C11.9736 4.17489 11.6562 4.28339 11.5256 4.54711L9.64949 8.38782L5.45256 9.00373C5.33685 9.02043 5.23106 9.07551 5.15007 9.15897C5.05215 9.26059 4.99819 9.39732 5.00005 9.5391C5.00191 9.68088 5.05943 9.81611 5.15998 9.91509L8.19652 12.9045L7.47912 17.1258C7.4623 17.224 7.47306 17.325 7.51018 17.4173C7.54731 17.5097 7.60931 17.5896 7.68916 17.6482C7.76901 17.7068 7.86352 17.7416 7.96196 17.7486C8.0604 17.7557 8.15883 17.7348 8.24611 17.6883L12 15.6953L15.754 17.6883C15.8564 17.7434 15.9755 17.7617 16.0895 17.7417C16.3771 17.6916 16.5705 17.4162 16.5209 17.1258L15.8036 12.9045L18.8401 9.91509C18.9227 9.8333 18.9773 9.72647 18.9938 9.60963C19.0384 9.31753 18.8368 9.04713 18.5475 9.00373Z"
                  fill="#212121"
                />
              </svg>
            </span>
            <span>{{ props.post.frisbuyPost.rating }}</span>
          </div>
        </div>

        <div class="frisbuy-text-modal__body">
          <p
            v-if="props.post.frisbuyPost.positiveComment"
            class="frisbuy-text-modal__block"
          >
            <span class="frisbuy-text-modal__label">Преимущества:</span>
            {{ props.post.frisbuyPost.positiveComment }}
          </p>

          <p
            v-if="props.post.frisbuyPost.negativeComment"
            class="frisbuy-text-modal__block"
          >
            <span class="frisbuy-text-modal__label">Недостатки:</span>
            {{ props.post.frisbuyPost.negativeComment }}
          </p>

          <p
            v-if="props.post.frisbuyPost.text"
            class="frisbuy-text-modal__comment"
          >
            {{ props.post.frisbuyPost.text }}
          </p>
        </div>
      </div>

      <div class="frisbuy-text-modal__footer" aria-hidden="true"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted } from "vue";
import { IMarketplaceReviewsPost } from "../../interfaces";

const props = defineProps<{
  post: IMarketplaceReviewsPost;
  selectedPostIndex: number;
  reviewDate: string;
}>();

const emit = defineEmits<{
  close: [];
}>();

const avatarColors = [
  "rgba(188, 200, 210, 1)",
  "rgba(114, 207, 154, 1)",
  "rgba(158, 204, 246, 1)",
  "rgba(127, 131, 234, 1)",
  "rgba(121, 85, 72, 1)",
];

const authorName = computed(() => {
  return (
    props.post.instagramPost.authorUser.fio ||
    `@${props.post.instagramPost.authorUser.username}`
  );
});

const authorInitial = computed(() => {
  const name = authorName.value.trim();
  return (name[0] || "A").toUpperCase();
});

const avatarStyle = computed(() => {
  const index =
    (Math.max(1, props.selectedPostIndex + 1) - 1) % avatarColors.length;
  return { background: avatarColors[index] };
});

onMounted(() => {
  document.documentElement.style.overflow = "hidden";
});

onBeforeUnmount(() => {
  document.documentElement.style.overflow = "";
});
</script>

<style scoped lang="scss">
.frisbuy-text-modal {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 70px 16px;
  background: rgba(0, 0, 0, 0.7);
  font-family: Gilroy, "Segoe UI", Arial, sans-serif;
}

.frisbuy-text-modal__card {
  position: relative;
  width: min(392px, 100%);
  height: 100%;
  max-height: calc(100dvh - 140px);
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.28);
  overflow: hidden;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
}

.frisbuy-text-modal__header {
  position: relative;
  height: 40px;
  flex: 0 0 40px;
}

.frisbuy-text-modal__close {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  border: 0;
  background: transparent;
  cursor: pointer;
  z-index: 2;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.frisbuy-text-modal__scroll {
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 32px;
  box-sizing: border-box;
}

.frisbuy-text-modal__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-top: 0;
}

.frisbuy-text-modal__author {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.frisbuy-text-modal__avatar {
  width: 48px;
  min-width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 28px;
  line-height: 28px;
  font-weight: 400;
  flex: 0 0 auto;
}

.frisbuy-text-modal__meta {
  min-width: 0;
}

.frisbuy-text-modal__name {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: rgba(33, 33, 33, 1);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.frisbuy-text-modal__date {
  margin-top: 0;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}

.frisbuy-text-modal__rating {
  display: inline-flex;
  align-items: center;
  gap: 0;
  color: #212121;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  flex: 0 0 auto;
}

.frisbuy-text-modal__rating-icon {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 24px;
}

.frisbuy-text-modal__body {
  margin-top: 16px;
  color: rgba(33, 33, 33, 1);
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}

.frisbuy-text-modal__footer {
  height: 40px;
  flex: 0 0 40px;
}

.frisbuy-text-modal__block,
.frisbuy-text-modal__comment {
  margin: 0;
}

.frisbuy-text-modal__block + .frisbuy-text-modal__block,
.frisbuy-text-modal__block + .frisbuy-text-modal__comment,
.frisbuy-text-modal__comment + .frisbuy-text-modal__block {
  margin-top: 12px;
}

.frisbuy-text-modal__label {
  font-weight: 700;
  color: #212121;
}

@media screen and (max-width: 1024px) {
  .frisbuy-text-modal {
    padding: 0;
  }

  .frisbuy-text-modal__card {
    height: 100%;
    max-height: 100dvh;
    border-radius: 0;
  }

  .frisbuy-text-modal__header {
    position: sticky;
    top: 0;
    z-index: 3;
    background: #ffffff;
  }

  .frisbuy-text-modal__scroll {
    height: 100%;
    overflow-y: auto;
    padding: 0 16px 48px;
  }

  .frisbuy-text-modal__head {
    padding-top: 4px;
  }

  .frisbuy-text-modal__body {
    margin-top: 32px;
  }

  .frisbuy-text-modal__block + .frisbuy-text-modal__block,
  .frisbuy-text-modal__block + .frisbuy-text-modal__comment,
  .frisbuy-text-modal__comment + .frisbuy-text-modal__block {
    margin-top: 16px;
  }

  .frisbuy-text-modal__footer {
    display: none;
  }

  .frisbuy-text-modal__avatar {
    width: 48px;
    min-width: 48px;
    height: 48px;
    font-size: 28px;
    line-height: 28px;
  }
}

@media screen and (max-width: 414px) {
  .frisbuy-text-modal__card {
    width: 100%;
    max-width: 100%;
  }
}
</style>
